var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-tabs",
        {
          attrs: { left: "", color: "transparent" },
          model: {
            value: _vm.tabModel,
            callback: function($$v) {
              _vm.tabModel = $$v
            },
            expression: "tabModel"
          }
        },
        [
          _c("v-tab", { attrs: { href: "#tab-3" } }, [
            _vm._v("Flotas Compartidas")
          ])
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-layout",
        {
          staticStyle: { "padding-right": "10px" },
          attrs: { row: "", wrap: "" }
        },
        [
          _c("v-flex", { attrs: { xs12: "", sm6: "", md6: "" } }, [
            _c(
              "div",
              { attrs: { align: "left" } },
              [
                _c("v-text-field", {
                  attrs: {
                    "append-icon": "search",
                    label: "Buscar...",
                    "single-line": "",
                    "hide-details": ""
                  },
                  on: { input: _vm.onFilterTextBoxChanged },
                  model: {
                    value: _vm.search,
                    callback: function($$v) {
                      _vm.search = $$v
                    },
                    expression: "search"
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "v-layout",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.muestraBarraBotones,
              expression: "muestraBarraBotones"
            }
          ],
          staticClass: "animated fadeIn fast",
          attrs: { row: "", wrap: "" }
        },
        [
          _c(
            "div",
            { attrs: { "data-permiso": "Editar" } },
            [
              _c(
                "v-flex",
                { attrs: { md3: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-barra",
                      attrs: { "data-permiso": "Editar", flat: "", small: "" },
                      on: {
                        click: function($event) {
                          return _vm.dejarRecibirInformacion()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("delete")]),
                      _vm._v("  Dejar de Recibir Información\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("v-divider"),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c("ag-grid-vue", {
            staticClass: "ag-theme-material",
            staticStyle: {
              width: "100%",
              height: "400px",
              "font-family": "'Asap', sans-serif"
            },
            attrs: { gridOptions: _vm.gridOptions }
          })
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogEliminar,
          titulo: _vm._titulo,
          mensaje: _vm._mensaje,
          textoBtnSi: "Aceptar",
          textoBtnNo: "Cancelar"
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.deleteItemCallback($event)
          }
        }
      }),
      _c("app-vehiculos-compartidos", {
        attrs: { show: _vm.showModalVehiculos, flota: _vm.editedItem },
        on: {
          modalAsociacionEmit: function($event) {
            return _vm.flotaModalCallback($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }